import {
  AddProductToCartVariables,
  AddProductToCart_AddProductToCart,
} from '@sharedComponents/AddToCartButton/queries/__generated__/AddProductToCart';
import { CartAddProductWithServiceVariables } from '@sharedComponents/AddToCartButton/queries/__generated__/CartAddProductWithService';

import { IAddToCart, IDeprecatedAddToCart } from '../model';

export const addToCartDeprecated = async ({
  cartAddToCartDeprecated,
  product,
  count,
  userProductsInfo,
  services,
}: IDeprecatedAddToCart) => {
  const productToCart = {
    id: Number(product.id),
    count,
    isUpselling: false,
    comparisonPrice: userProductsInfo.some(
      (upi) => upi.productId === product.id && upi.isComparison
    ),
  };

  const variables: CartAddProductWithServiceVariables = {
    cart: {
      products: [productToCart],
    },
    services: services && services.length > 0 ? services : [],
  };
  try {
    const response = await cartAddToCartDeprecated({ variables });
    if (response) {
      return {
        response,
        success: true,
      };
    }
  } catch (_) {
    return {
      success: false,
      response: {},
    };
  }
};

type AddToCartReturn =
  | {
      success: true;
      response: AddProductToCart_AddProductToCart;
    }
  | {
      success: false;
    };

export const addToCart = async ({
  addToCartMutation,
  product,
  count,
  userProductsInfo,
  services,
}: IAddToCart): Promise<AddToCartReturn> => {
  const variables: AddProductToCartVariables = {
    product: {
      count,
      productId: Number(product.id),
      isComparisonPrice: userProductsInfo.some(
        (upi) => upi.productId === product.id && upi.isComparison
      ),
    },
    services: services && services.length > 0 ? services : [],
  };

  try {
    const response = await addToCartMutation({ variables });
    if (response?.data?.AddProductToCart) {
      return {
        response: response.data.AddProductToCart,
        success: true,
      };
    }
    return {
      success: false,
    };
  } catch (err) {
    return {
      success: false,
    };
  }
};
